export enum OrderStatus {
    Created = 'created',
    PendingExecution = 'pending_execution',
    PendingApproval = 'pending_approval',
    Declined = 'declined',
    Canceled = 'canceled',
    Failed = 'failed',
    InProgress = 'in_progress',
    PartialDelivery = 'partial_delivery',
    Completed = 'completed',
    ExecutionError = 'execution_error',
    Returned = 'returned',
    ReadyToConnect = 'ready_to_connect',
    Initializing = 'initialize',
    PendingAV = 'pending_av',
}

export const FINITE_ORDER_STATUSES: ReadonlySet<OrderStatus> = new Set([
    OrderStatus.Declined,
    OrderStatus.Completed,
    OrderStatus.Canceled,
    OrderStatus.Failed,
    OrderStatus.ExecutionError,
    OrderStatus.Returned,
])

export type OrderStatusObj = {
    name: OrderStatus
    message?: string
}

export enum OrderInternalStatus {
    PendingMissingData = 'pending_missing_data',
    Paused = 'paused',
    Playing = 'playing',
}

export type OrderInternalStatusObj = {
    name?: OrderInternalStatus
    message?: string
}

export enum ServiceType {
    Live = 'live',
    Offline = 'offline',
}

export type ScheduleItem = {
    recurrence?: false
    start_at: string
    timezone?: string
    max_duration?: number
}

export type RecurrenceScheduleItem = {
    recurrence?: true
    start_at: string
    timezone?: string
    max_duration?: number
    recurrence_id?: string
    rrule?: string
    occurrence_index?: number
}

export type OrderInputSchedule = ScheduleItem | RecurrenceScheduleItem

// Common fields across all input connection types (onsite, websocket, rtmp, etc.)
export type OrderInput = {
    type?: string
    language?: string
    schedule?: OrderInputSchedule
    glossary?: string[]
    notes?: string
    external_urls?: string[]
    connection_params?: Record<string, unknown>
    connection_plan?: Record<string, unknown>
}

export type UpdateScheduleItem = {
    start_at?: string
    max_duration?: number
    timezone?: string
}

export type UpdateOrderInputConn = {
    schedule?: UpdateScheduleItem
    glossary?: string[]
    external_urls?: string[]
    notes?: string
    connection_plan?: Record<string, unknown>
    connection_params?: Record<string, unknown>
}

export type OrdersUpdateRequest = {
    name?: string
    category_id?: string
    client_transaction_id?: string
    status?: OrderStatusObj
    internal_status?: OrderInternalStatusObj
    input?: UpdateOrderInputConn
    po_number?: string
    cost_center?: string
    settings?: unknown
    contact_details?: unknown
    attachments?: string[]
    groups?: unknown[]
    psr_product_id?: string
    editor_ids?: string[]
}

export type Order = {
    id: string
    category_id?: string
    short_id: string
    transcription_job_id: string
    name: string
    client_transaction_id: string
    status: OrderStatusObj
    internal_status: OrderInternalStatusObj
    last_updated_at: string
    input: OrderInput
    output: unknown[]
    po_number?: string
    cost_center?: string
    service_type: ServiceType
    settings?: unknown
    contact_details?: unknown
    request_origin?: string
    attachments?: unknown[]
    created_by?: unknown
    container?: unknown
    groups?: unknown[]
    created_at: string
    verbitext_group_id?: string
    editor_ids?: string[]
    collections: unknown[]
}

export type OrderResponse = {
    order: Order
}
